import clsx from 'clsx';
import Card from 'components/atoms/Card/Card';
import Heading from 'components/atoms/Heading/Heading';
import Txt from 'components/atoms/Txt/Txt';
import RedemptionTypesButtons, {
  RedemptionType,
} from 'components/molecules/RedemptionTypesButtons/RedemptionTypesButtons';
import React from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay';
import {
  RedemptionTypeKey,
  RedemptionTypesCardQuery,
} from './__generated__/RedemptionTypesCardQuery.graphql';
import classes from './RedemptionTypesCard.module.scss';

export interface Props {
  redemptionType?: RedemptionTypeKey;
  onRedemptionTypeSelect?: (type: RedemptionType) => void;
}

const query = graphql`
  query RedemptionTypesCardQuery($optionsInput: RedemptionOptionsInput!) {
    redemptionTypes {
      ...RedemptionTypesButtons_redemptionTypes
    }
    redemptionOptions(input: $optionsInput) {
      edges {
        node {
          id
          ...useRedemptionOptionItemQuery_optionRef
        }
      }
    }
    walletBalance {
      ...CurrentEarningsCard_currentEarnings
    }
  }
`;

const LABEL_MAPPINGS = {
  PAYPAL: 'PayPal',
  VENMO: 'Venmo',
  GIFT_CARD: 'Gift cards',
  CHARITY: 'Charity',
};

export default function RedemptionTypesCard({ redemptionType, onRedemptionTypeSelect }: Props) {
  const [currentRedemptionTypeKey, setRedemptionType] = React.useState<RedemptionTypeKey>(
    redemptionType || 'GIFT_CARD',
  );
  const input = React.useMemo(
    () => ({
      optionsInput: { redemptionType: currentRedemptionTypeKey },
      linkInput: { redirectUrl: window.location.href },
    }),
    [currentRedemptionTypeKey],
  );
  const data = useLazyLoadQuery<RedemptionTypesCardQuery>(query, input, {
    fetchPolicy: 'store-and-network',
  });

  return (
    <Card>
      <Heading level={3}>Reward Options</Heading>
      <Txt>
        LifePoints offers a range of rewards spanning from cash transfers using apps, such as
        PayPal, to e-gift cards and charity donations. Explore your options below.
      </Txt>
      {data.redemptionTypes && (
        <RedemptionTypesButtons
          redemptionTypesRef={data.redemptionTypes}
          className={clsx(classes.redemptionTypesButtons)}
          onRedemptionTypeSelect={onRedemptionTypeSelect}
        />
      )}
    </Card>
  );
}
